const DEFAULT_MIN_LINES = 2

/**
 * Directive class for vdTextarea. Allows a textarea to grow as new text is entered. Allows a min and max number of
 * lines to be set, defaulting to a min height of 2 lines.
 */
const VdTextarea = $window => {
  'ngInject'
  return {
    restrict: 'A',
    require: 'ngModel',
    link(scope, $element, attrs, ngModel) {
      // Set ngTrim to false to ensure 'return' key is registered in the ngModel.$viewValue watch
      attrs.$set('ngTrim', 'false')

      // Add styles
      $element.addClass('vd-input vd-textarea')

      /**
       * Optional settings for vdTextarea
       *
       * vdTextarea {Object}
       *
       *			[min=2] {Number}
       *  					The minimum number of lines for the textarea.
       *
       *			[max] {Number}
       *  					The maximum number of lines for the textarea before scrolling.
       */
      const options = scope.$eval(attrs.vdTextarea) || {}

      const textareaNode = $element[0]
      const textareaStyles = $window.getComputedStyle(textareaNode)

      const minLineCount = options.min || DEFAULT_MIN_LINES
      const paddingOffset =
        parseFloat(textareaStyles.paddingTop) +
        parseFloat(textareaStyles.paddingBottom)
      const lineHeight = parseFloat(textareaStyles.lineHeight)

      const minHeight = minLineCount * lineHeight + paddingOffset
      const maxHeight = options.max && options.max * lineHeight + paddingOffset

      /**
       * Adjust the height of the textarea when the input is updated.
       *
       * @function resize
       */
      function resize() {
        textareaNode.style.height = '0'

        const resizedMaxHeight =
          (maxHeight && Math.min(textareaNode.scrollHeight, maxHeight)) ||
          textareaNode.scrollHeight
        const height = Math.max(resizedMaxHeight, minHeight)

        $element.toggleClass(
          'vd-textarea--scrollable',
          resizedMaxHeight === maxHeight
        )

        textareaNode.style.height = `${height}px`
      }

      scope.$watch(
        () => ngModel.$viewValue,
        () => resize()
      )
    },
  }
}

export default VdTextarea
